import { render } from "./ModelAnswerPage.vue?vue&type=template&id=9ba6d344&scoped=true&ts=true"
import script from "./ModelAnswerPage.vue?vue&type=script&lang=ts"
export * from "./ModelAnswerPage.vue?vue&type=script&lang=ts"

import "./ModelAnswerPage.vue?vue&type=style&index=0&id=9ba6d344&lang=postcss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ba6d344"]])

export default __exports__